import styles from "./profile-icon.module.css";

import { ClientProfile } from "../../../../../components/svg";
import { ClientProfileWarning } from "../../../../../components/svg";
import { ClientProfileCritical } from "../../../../../components/svg";
import {
  getWarningType,
  WARNING_TYPE,
} from "../../../../../components/sensor-issues-mapper";

interface ProfileIconProps {
  sensorIssues: any;
  onClick(): void;
}

export default function ProfileIcon(props: ProfileIconProps): any {
  const ProfileIcon = getProfileIcon(props.sensorIssues);

  return (
    <span className={styles["profile-icon"]} onClick={props.onClick}>
      <ProfileIcon width="40px" height="40px" />
    </span>
  );
}

function getProfileIcon(sensorIssues: any) {
  if (!sensorIssues || sensorIssues.length === 0) return ClientProfile;

  const warningType = getWarningType(sensorIssues);

  if (warningType === WARNING_TYPE.Yellow) return ClientProfileWarning;
  if (warningType === WARNING_TYPE.Red) return ClientProfileCritical;

  return ClientProfile;
}
